module.exports = "https://img.xiyuyouxi.com/saas/img/fo_icon.60082df3.png";